import { create } from 'zustand';

import { DEVICES } from '../constants/devices';

export type Device = {
  brand: string;
  color: string;
  id: string;
  imageUrl: string;
  model: string;
  orientation: 'Landscape' | 'Portrait';
  viewportHeight: number;
  viewportWidth: number;
  viewportOffsetX: number;
  viewportOffsetY: number;
};

export type Color = {
  color: string;
  imageUrl: string;
};

export type GroupedDevice = {
  brand: string;
  colors: Color[];
  id: string;
  model: string;
};

export type InputFile = {
  compatibleDeviceIds: string[];
  file: File;
  id: string;
  imageHeight: number;
  imageWidth: number;
  selectedDeviceIds: string[];
};

export type State = {
  devices: GroupedDevice[];
  inputFiles: InputFile[];
  setDeviceIdsForInputFile: (inputFileId: string, selectedDeviceIds: string[]) => void;
};

const devices = DEVICES.reduce<Record<string, GroupedDevice>>((acc, device) => {
  const { brand, color, imageUrl, model, orientation } = device;

  if (orientation === 'Portrait') {
    const key = `${brand}-${model}`;

    acc[key] = acc[key] ?? {
      brand,
      colors: [],
      id: key,
      model,
    };

    acc[key]?.colors.push({
      color,
      imageUrl,
    });
  }

  return acc;
}, {});

export const useStore = create<State>()((set) => ({
  devices: Object.values(devices),
  inputFiles: [],
  setDeviceIdsForInputFile(inputFileId, selectedDeviceIds) {
    set((state) => ({
      inputFiles: state.inputFiles.map((item) => {
        if (item.id === inputFileId) {
          return {
            ...item,
            selectedDeviceIds,
          };
        }

        return item;
      }),
    }));
  },
}));
